export default __webpack_public_path__ + "static/media/CNo.73-4.d359f1e9.jpg";